export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4634.41d3d7af.jpg";